import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SparkleProps {
    className?: string
    style?: CSSProperties
}

// A soft four-point star with curved sides.
const Sparkle: FC<SparkleProps> = ({ className, style }): ReactNode => {
    return (
        <svg viewBox='0 0 24 24' className={cn('block', className)} style={style} aria-hidden='true' focusable='false'>
            <path d='M12 0C12.7 6.4 17.6 11.3 24 12C17.6 12.7 12.7 17.6 12 24C11.3 17.6 6.4 12.7 0 12C6.4 11.3 11.3 6.4 12 0Z' fill='currentColor' />
        </svg>
    )
}

export default Sparkle
